module.exports = __webpack_public_path__ + "ptc_momoro_I1.0827abb5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/momoro/parent_to_child/ptc_momoro_I1.jpg
// module id = aohy
// module chunks = 0